<template lang="pug">
UiModal(
  :show="show"
  @close="close"
  :title="$t('resellers.edit')"
  :subtitle="$t('resellers.edit_description')"
  :rightActions="rightActions"
)
  UiFormGroup(
    :label="$t('resellers.name')"
    :vuelidateModel="v$.form.name"
  )
    UiInput#name-input(
      v-model="form.name"
      :error="v$.form.name.$error"
    )

  UiFormGroup(
    :label="$t('resellers.business_id')"
    :vuelidateModel="v$.form.company_id"
  )
    UiInput#business-id-input(
      v-model="form.company_id"
      :error="v$.form.company_id.$error"
    )

  UiFormGroup(
    :label="$t('resellers.einvoice_address')"
    :vuelidateModel="v$.form.einvoice_address"
  )
    UiInput#einvoice-address-input(
      v-model="form.einvoice_address"
      :error="v$.form.einvoice_address.$error"
    )

  UiFormGroup(
    :label="$t('resellers.einvoice_operator_address')"
    :vuelidateModel="v$.form.einvoice_operator_address"
  )
    UiInput#einvoice-operator-address-input(
      v-model="form.einvoice_operator_address"
      :error="v$.form.einvoice_operator_address.$error"
    )

  UiFormGroup(:label="$t('resellers.domain')")
    UiInput#domain-input(v-model="form.domain")
</template>

<script>
import Reseller from "@/models/Reseller";
import ApiResellers from "@/api/resellers.js";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  validations() {
    return {
      form: {
        name: {
          required,
        },
        company_id: {
          required,
        },
        einvoice_address: {
          required,
        },
        einvoice_operator_address: {
          required,
        },
      },
    };
  },

  data() {
    return {
      show: false,
      form: new Reseller(),
    };
  },

  computed: {
    rightActions() {
      return [
        {
          label: this.$t("actions.save"),
          icon: "Check",
          onClick: this.save,
        },
      ];
    },
  },

  methods: {
    open(reseller) {
      this.v$.$reset();
      this.form = new Reseller(reseller);
      this.show = true;
    },

    close() {
      this.show = false;
    },

    save() {
      this.v$.$validate().then((res) => {
        if (!res) return;
        const form = this.form;
        const params = {
          name: form.name,
          company_id: form.company_id,
          einvoice_address: form.einvoice_address,
          einvoice_operator_address: form.einvoice_operator_address,
        };
        ApiResellers.createReseller(params).then((res) => {
          this.$emit("done");
          this.close();
        });
      });
    },
  },
};
</script>
